var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "box",
      staticStyle: {
        "background-color": "hsl(229, 53%, 96%)",
        padding: "12px",
      },
    },
    [
      _c("h1", { staticClass: "title is-4" }, [
        _vm._v("Opciones del empleador"),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "subtitle is-6" }, [
        _vm._v("Seleccione el firmador a utilizar"),
      ]),
      _vm._v(" "),
      _vm.user && _vm.user.firmadores_habilitados.pfdrar
        ? _c(
            "div",
            {
              staticClass:
                "box is-flex is-flex-direction-row is-align-items-center p-2",
            },
            [
              _c(
                "div",
                { staticClass: "is-flex-grow-1" },
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { disabled: "", "native-value": "pfdrar" },
                      model: {
                        value: _vm.firmadorSelected,
                        callback: function ($$v) {
                          _vm.firmadorSelected = $$v
                        },
                        expression: "firmadorSelected",
                      },
                    },
                    [
                      _c("p", { staticClass: "has-text-danger is-size-7" }, [
                        _vm._v("No disponible"),
                      ]),
                      _vm._v(" "),
                      _c("b", [_vm._v("Plataforma de Firma Digital Remota")]),
                      _vm._v(
                        " - Secretaria de Modernización - Argentina\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              1 === 2
                ? _c("img", {
                    staticClass: "image firmador-select",
                    attrs: { src: "/statics/pfdrar-logo.png", alt: "" },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.user && _vm.user.firmadores_habilitados.signar
        ? _c(
            "div",
            {
              staticClass:
                "box is-flex is-flex-direction-row is-align-items-center p-3",
            },
            [
              _c(
                "div",
                { staticClass: "is-flex-grow-1" },
                [
                  _c(
                    "b-radio",
                    {
                      attrs: { "native-value": "signar_v3" },
                      model: {
                        value: _vm.firmadorSelected,
                        callback: function ($$v) {
                          _vm.firmadorSelected = $$v
                        },
                        expression: "firmadorSelected",
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-upload fa-fw" }),
                      _c("b", [_vm._v(" Firmador Integrable v3")]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c(
                      "label",
                      {
                        staticClass: "subtitle is-6",
                        class: {
                          "has-text-grey-light":
                            _vm.firmadorSelected != "signar_v3",
                        },
                        attrs: { for: "" },
                      },
                      [
                        _vm._v(
                          "\n                Seleccione el tipo de recibo a subir"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "select is-fullwidth" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.tipoRecibosSelected,
                              expression: "tipoRecibosSelected",
                            },
                          ],
                          style: {
                            opacity:
                              _vm.firmadorSelected != "signar_v3" ? 0.5 : 1,
                          },
                          attrs: {
                            name: "",
                            disabled: _vm.firmadorSelected != "signar_v3",
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.tipoRecibosSelected = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        _vm._l(_vm.tiposRecibos, function (recibo, i) {
                          return _c(
                            "option",
                            { key: i, domProps: { value: recibo.id } },
                            [_vm._v(_vm._s(recibo.nombre))]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "buttons is-centered" }, [
        _c(
          "button",
          {
            staticClass: "button is-primary is-fullwidth",
            attrs: {
              disabled:
                !_vm.firmadorSelected ||
                (_vm.firmadorSelected === "signar_v3" &&
                  !_vm.tipoRecibosSelected),
            },
            on: {
              click: function ($event) {
                return _vm.goFirmar(_vm.firmadorSelected)
              },
            },
          },
          [
            _c("i", { staticClass: "fas fa-upload fa-fw" }),
            _vm._v(" Subir Recibos"),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          attrs: {
            open: false,
            position: "is-top",
            "aria-id": "contentIdForA11y1",
          },
          scopedSlots: _vm._u([
            {
              key: "trigger",
              fn: function (props) {
                return [
                  _c(
                    "a",
                    {
                      staticClass: "is-size-7 has-text-dark",
                      attrs: { "aria-controls": "contentIdForA11y1" },
                    },
                    [
                      _c("i", {
                        staticClass: "fas",
                        class: !props.open ? "fa-caret-down" : "fa-caret-up",
                      }),
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            !props.open ? "Más opciones" : "Ocultar opciones"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "mt-3 is-size-7" }, [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("launch-firmador", "jnlp")
                  },
                },
              },
              [
                _c("i", { staticClass: "fas fa-upload fa-fw" }),
                _vm._v(" Subir recibos usando el firmador JNLP (legacy)"),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }